<div class="grid" *ngIf="currentUser.tipo !== TIPO_ADMINISTRADOR">
    <div
        class="col-12 md:col-3 tarjeta animacion animate__animated animate__backInUp"
        (click)="accesosDirectos(PORTAL_PAGOS)"
    >
        <div class="card grid relative border-round-xl tarjetas_cajero p-2">
            <div class="col-3 flex justify-content-start">
                <img
                    src="../../../../assets/images/portal_pago.png"
                    alt="Imagen Gráficos"
                    class="centered-cajero"
                />
            </div>
            <div class="col-9 flex justify-content-start text-center pr-0">
                <label>PORTAL DE PAGOS</label>
            </div>
        </div>
    </div>
    <div
        class="col-12 md:col-3 tarjeta animacion animate__animated animate__backInUp"
        (click)="accesosDirectos(ACREDITACIONES)"
    >
        <div class="card grid relative border-round-xl tarjetas_cajero p-2">
            <div class="col-3 flex justify-content-start">
                <img
                    src="../../../../assets/images/acreditaciones2.png"
                    alt="Imagen Gráficos"
                    class="centered-cajero"
                />
            </div>
            <div class="col-9 flex justify-content-start text-center pr-0">
                <label>ACREDITACIONES</label>
            </div>
        </div>
    </div>
    <div
        class="col-12 md:col-3 tarjeta animacion animate__animated animate__backInUp"
        (click)="accesosDirectos(ARQUEO_CAJA)"
    >
        <div class="card grid relative border-round-xl tarjetas_cajero p-2">
            <div class="col-3 flex justify-content-start">
                <img
                    src="../../../../assets/images/arqueo.png"
                    alt="Imagen Gráficos"
                    class="centered-cajero"
                />
            </div>
            <div class="col-9 flex justify-content-start text-center pr-0">
                <label>ARQUEOS</label>
            </div>
        </div>
    </div>
    <div
        class="col-12 md:col-3 tarjeta animacion animate__animated animate__backInUp"
        (click)="accesosDirectos(COBROS)"
    >
        <div class="card grid relative border-round-xl tarjetas_cajero p-2">
            <div class="col-3 flex justify-content-start">
                <img
                    src="../../../../assets/images/finanzas.png"
                    alt="Imagen Gráficos"
                    class="centered-cajero"
                />
            </div>
            <div class="col-9 flex justify-content-start text-center pr-0">
                <label>COBROS</label>
            </div>
        </div>
    </div>
</div>

<!-- Seccion para la empresa autogestion -->
<div
    class="grid animacion animate__animated animate__fadeIn"
    *ngIf="empresaAutogestion"
>
    <div class="col-12 md:col-3">
        <div
            class="card card-autogestion flex flex-column text-align-center align-items-center"
        >
            <b class="mb-2">TOTAL CREDITO</b>
            <b class="card-importe border-round p-2">{{
                empresaAutogestion.limite_credito
                    | currency : "" : "Gs." : "0.0-0" : "es-PY"
            }}</b>
        </div>
    </div>
    <div class="col-12 md:col-3">
        <div
            class="card card-autogestion flex flex-column text-align-center align-items-center"
        >
            <b class="mb-2">DISTRIBUIDO</b>
            <b class="card-generada border-round p-2">{{
                empresaAutogestion.credito_distribuido
                    | currency : "" : "Gs." : "0.0-0" : "es-PY"
            }}</b>
        </div>
    </div>
    <div class="col-12 md:col-3">
        <div
            class="card card-autogestion flex flex-column text-align-center align-items-center"
        >
            <b class="mb-2">USADO</b>
            <b class="card-pagar border-round p-2">{{
                empresaAutogestion.consumo_credito
                    | currency : "" : "Gs." : "0.0-0" : "es-PY"
            }}</b>
        </div>
    </div>
    <div class="col-12 md:col-3">
        <div
            class="card card-autogestion flex flex-column text-align-center align-items-center"
        >
            <b class="mb-2">DISPONIBLE</b>
            <b class="card-neta border-round p-2">{{
                empresaAutogestion.limite_credito -
                    empresaAutogestion.consumo_credito
                    | currency : "" : "Gs." : "0.0-0" : "es-PY"
            }}</b>
        </div>
    </div>
</div>
<!-- Seccion para la empresa autogestion -->

<div
    class="grid pt-3"
    [ngClass]="{
        'justify-content-between': permiso_administrador,
        'justify-content-center': !permiso_administrador
    }"
>
    <div
        class="col-12 md:col-3 tarjeta animacion animate__animated animate__backInUp"
    >
        <div class="card grid relative border-round-xl tarjetas p-2">
            <div
                class="line-height-3 col-9 flex-column p-0"
                style="font-size: 0.9rem"
            >
                <span class="flex justify-content-start pb-1"
                    ><b>IMPORTE COBRADO</b></span
                >
                <div
                    class="flex justify-content-start align-items-center p-1 border-round card-importe"
                >
                    <span class="line-height-2">
                        <b>{{
                            tarjetas.importeCobrado.cobrado
                                | currency : "" : "Gs." : "0.0-0" : "es-PY"
                        }}</b></span
                    >
                </div>
            </div>
            <div class="col-3 flex justify-content-start pb-0">
                <img
                    src="../../../../assets/images/importe.png"
                    alt="Imagen Gráficos"
                    class="centered-image3"
                />
            </div>
            <div
                class="flex col-12 align-items-center pl-2 pb-0 pt-0 total-card"
            >
                <div>
                    <b
                        >Total del mes:
                        {{
                            tarjetas.importeCobrado.cobro_mes
                                | currency : "" : "Gs." : "0.0-0" : "es-PY"
                        }}</b
                    >
                </div>
            </div>
            <div
                class="flex col-12 justify-content-end align-items-center p-0 pr-1"
                style="font-size: 0.7rem"
            >
                <b
                    >Transacciones:
                    {{
                        tarjetas.importeCobrado.transaciones
                            | currency : "" : "" : "0.0-0" : "es-PY"
                    }}</b
                >
            </div>
        </div>
    </div>
    <div *ngIf="permiso_administrador" class="col-12 md:col-3 tarjeta">
        <div class="card grid relative border-round-xl tarjetas p-2">
            <div
                class="line-height-3 col-9 flex-column p-0"
                style="font-size: 0.9rem"
            >
                <span class="flex justify-content-start pb-1"
                    ><b>COMISION GENERADA</b></span
                >
                <div
                    class="flex justify-content-start align-items-center p-1 border-round card-generada"
                >
                    <span class="line-height-2">
                        <b>{{
                            tarjetas.comisionGenerada.comision_servicio
                                | currency : "" : "Gs." : "0.0-0" : "es-PY"
                        }}</b></span
                    >
                </div>
            </div>
            <div class="col-3 flex justify-content-start pb-0">
                <img
                    src="../../../../assets/images/comision.png"
                    alt="Imagen Gráficos"
                    class="centered-image2"
                />
            </div>
            <div
                class="flex col-12 align-items-center pl-2 pb-0 pt-0 total-card"
            >
                <div>
                    Total del mes:
                    {{
                        tarjetas.comisionGenerada.comision_servicio_mes
                            | currency : "" : "Gs." : "0.0-0" : "es-PY"
                    }}
                </div>
            </div>
            <div
                class="flex col-12 justify-content-end align-items-center p-0 pr-1"
                style="font-size: 0.7rem"
            >
                <b>A cobrar a comercios</b>
            </div>
        </div>
    </div>
    <div class="col-12 md:col-3 tarjeta">
        <div class="card grid relative border-round-xl tarjetas p-2">
            <div
                class="line-height-3 col-9 flex-column p-0"
                style="font-size: 0.9rem"
            >
                <span class="flex justify-content-start pb-1">
                    <b>{{
                        permiso_administrador
                            ? "COMISION A PAGAR"
                            : "COMISION A COBRAR"
                    }}</b>
                </span>
                <div
                    class="flex justify-content-start align-items-center p-1 border-round card-pagar"
                >
                    <span class="line-height-2">
                        <b>{{
                            tarjetas.comisionAPagar.comision_boca
                                | currency : "" : "Gs." : "0.0-0" : "es-PY"
                        }}</b></span
                    >
                </div>
            </div>
            <div class="col-3 flex justify-content-start pb-0">
                <img
                    src="../../../../assets/images/tarjeta.png"
                    alt="Imagen Gráficos"
                    class="centered-image2"
                />
            </div>
            <div
                class="flex col-12 align-items-center pl-2 pb-0 pt-0 total-card"
            >
                <div>
                    Total del mes:
                    {{
                        tarjetas.comisionAPagar.comision_boca_mes
                            | currency : "" : "Gs." : "0.0-0" : "es-PY"
                    }}
                </div>
            </div>
            <div
                *ngIf="permiso_administrador"
                class="flex col-12 justify-content-end align-items-center p-0 pr-1"
                style="font-size: 0.7rem"
            >
                <b>A abonar a bocas</b>
            </div>
        </div>
    </div>
    <div *ngIf="permiso_administrador" class="col-12 md:col-3 tarjeta">
        <div class="card grid relative border-round-xl tarjetas p-2">
            <div
                class="line-height-3 col-9 flex-column p-0"
                style="font-size: 0.9rem"
            >
                <span class="flex justify-content-start pb-1"
                    ><b>COMISION NETA</b></span
                >
                <div
                    class="flex justify-content-start align-items-center p-1 border-round card-neta"
                >
                    <span class="line-height-2">
                        <b>{{
                            tarjetas.comisionNeta.comision
                                | currency : "" : "Gs." : "0.0-0" : "es-PY"
                        }}</b></span
                    >
                </div>
            </div>
            <div class="col-3 flex justify-content-start pb-0">
                <img
                    src="../../../../assets/images/salarioverd.png"
                    alt="Imagen Gráficos"
                    class="centered-image"
                />
            </div>
            <div
                class="flex col-12 align-items-center pl-2 pb-0 pt-0 total-card"
            >
                <div>
                    Total del mes:
                    {{
                        tarjetas.comisionNeta.comision_mes
                            | currency : "" : "Gs." : "0.0-0" : "es-PY"
                    }}
                </div>
            </div>
            <div
                class="flex col-12 justify-content-end align-items-center p-0 pr-1"
                style="font-size: 0.8rem; margin-top: 1rem"
            ></div>
        </div>
    </div>
</div>
<div
    class="grid dashboard animate__animated animate__fadeIn"
    *ngIf="!permiso_boca"
>
    <div class="card col-12">
        <div
            class="flex flex-row justify-content-center animate__animated animate__fadeIn"
        >
            <div class="flex flex-column">
                <div class="flex flex-row justify-content-center">
                    <span
                        class="p-1 m-1"
                        [ngStyle]="{
                            'font-size': isMobileView ? '0.8rem' : '1rem',
                            'margin-right': isMobileView ? '1rem' : '2rem',
                            'font-family': 'Arial Black'
                        }"
                    >
                        <span *ngIf="empresaSeleccionada?.id_empresa">
                            {{ empresaSeleccionada.nombre_empresa }} -
                        </span>
                        <b
                            >Transacciones:
                            <span
                                style="
                                    color: rgb(255, 247, 0);
                                    width: 1rem;
                                    padding-right: 1rem;
                                "
                                ><b>{{
                                    transacciones
                                        | currency : "" : "" : "0.0-0" : "es-PY"
                                }}</b></span
                            ></b
                        >
                        <b>
                            Total:
                            <span style="color: rgb(255, 247, 0)"
                                ><b>{{
                                    totalCobro
                                        | currency : "" : "" : "0.0-0" : "es-PY"
                                }}</b></span
                            ></b
                        >
                    </span>
                </div>
                <div class="flex flex-row justify-content-center">
                    <p-selectButton
                        [unselectable]="true"
                        [options]="opcionesBarra"
                        [(ngModel)]="opcionSeleccionada"
                        optionLabel="name"
                        optionValue="code"
                        (onChange)="onChangeBarra($event)"
                    ></p-selectButton>
                </div>
                <div
                    class="flex flex-row justify-content-center"
                    *ngIf="opcionSeleccionada === DIA"
                >
                    <button
                        pButton
                        pRipple
                        class="p-button-success"
                        [ngClass]="isMobileView ? 'btn-small' : 'btn-normal'"
                        [label]="isMobileView ? '' : 'Limpiar Filtro'"
                        icon="pi pi-filter-slash"
                        (click)="limpiarFiltro()"
                    ></button>
                    <p-calendar
                        class="pr-1 pl-1 pt-2"
                        [ngClass]="isMobileView ? 'date-small' : 'date-normal'"
                        [(ngModel)]="fromDate"
                        dateFormat="dd/mm/yy"
                        appendTo="body"
                    ></p-calendar>
                    <p-calendar
                        class="pr-1 pt-2"
                        [ngClass]="isMobileView ? 'date-small' : 'date-normal'"
                        [(ngModel)]="toDate"
                        dateFormat="dd/mm/yy"
                        appendTo="body"
                    ></p-calendar>
                    <button
                        pButton
                        pRipple
                        class="p-button-success"
                        [ngClass]="isMobileView ? 'btn-small' : 'btn-normal'"
                        [label]="isMobileView ? '' : 'Buscar'"
                        icon="pi pi-search"
                        (click)="buscar()"
                    ></button>
                </div>
                <div
                    class="flex flex-row justify-content-center"
                    *ngIf="opcionSeleccionada === MES"
                >
                    <button
                        pButton
                        pRipple
                        class="p-button-success p-1"
                        [ngClass]="isMobileView ? 'btn-small' : 'btn-normal'"
                        [label]="isMobileView ? '' : 'Limpiar Filtro'"
                        icon="pi pi-filter-slash"
                        (click)="limpiarFiltro()"
                    ></button>
                    <p-calendar
                        class="pr-1 pl-1 pt-2"
                        [ngClass]="isMobileView ? 'date-small' : 'date-normal'"
                        [(ngModel)]="dateDesde"
                        view="month"
                        dateFormat="mm/yy"
                        appendTo="body"
                    ></p-calendar>
                    <p-calendar
                        class="pr-1 pt-2"
                        [ngClass]="isMobileView ? 'date-small' : 'date-normal'"
                        [(ngModel)]="dateHasta"
                        view="month"
                        dateFormat="mm/yy"
                        appendTo="body"
                    ></p-calendar>
                    <button
                        pButton
                        pRipple
                        class="p-button-success p-1"
                        [ngClass]="isMobileView ? 'btn-small' : 'btn-normal'"
                        [label]="isMobileView ? '' : 'Buscar'"
                        icon="pi pi-search"
                        (click)="buscar()"
                    ></button>
                </div>
            </div>
        </div>
        <p-chart
            type="bar"
            [data]="ordersChart"
            [options]="ordersOptions"
            height="300px"
        ></p-chart>
    </div>
</div>

<div class="grid dashboard animate__animated animate__fadeIn pt-4">
    <div
        class="col-12 p-1"
        *ngIf="
            (credito === POSPAGO &&
                isMobileView &&
                (permiso_administrador || contieneLimitePospago)) ||
            (!isMobileView && (permiso_administrador || contieneLimitePospago))
        "
        [ngClass]="{ 'md:col-12': permiso_boca, 'md:col-6': !permiso_boca }"
    >
        <div class="card p-3">
            <div class="grid flex justify-content-between">
                <div
                    class="col-12 md:col-7 flex text-items-center justify-content-center limite-credito"
                    *ngIf="!isMobileView"
                >
                    <b>Consumo de Límite de Crédito - POSPAGO</b>
                </div>
                <div
                    class="col-12 md:col-7 flex text-items-center justify-content-center"
                    *ngIf="isMobileView"
                >
                    <b>Consumo de Límite de Crédito</b>
                </div>
                <div
                    class="col-12 md:col-7 p-0"
                    *ngIf="isMobileView && filtro_admin"
                >
                    <p-selectButton
                        [unselectable]="true"
                        class="flex justify-content-center"
                        [(ngModel)]="credito"
                        [options]="tipo_creditos"
                        optionLabel="nombre"
                        optionValue="valor"
                        (onChange)="tipoCredito($event)"
                    ></p-selectButton>
                </div>
                <div class="p-inputgroup col-12 md:col-5">
                    <span class="p-inputgroup-addon"
                        ><i class="pi pi-search"></i
                    ></span>
                    <input
                        type="text"
                        pInputText
                        placeholder="Buscar..."
                        (keydown)="filterDataPospago($event)"
                    />
                </div>
            </div>

            <p-treeTable
                #dt
                [value]="limitePospago"
                dataKey="id"
                [paginator]="true"
                [rows]="10"
                [scrollable]="true"
                styleClass="p-treetable-gridlines"
                sortMode="single"
                [globalFilterFields]="['nombre']"
                filterMode="strict"
                [rowsPerPageOptions]="[10, 20, 50]"
            >
                >
                <ng-template pTemplate="header">
                    <tr>
                        <th [ttSortableColumn]="'nombre'" colspan="2">
                            Nombre <p-treeTableSortIcon [field]="'nombre'" />
                        </th>
                        <th></th>
                        <th [ttSortableColumn]="'limite_credito'">
                            Total
                            <p-treeTableSortIcon [field]="'limite_credito'" />
                        </th>
                        <th [ttSortableColumn]="'consumo_credito'">
                            Usado
                            <p-treeTableSortIcon [field]="'consumo_credito'" />
                        </th>
                        <th [ttSortableColumn]="'disponible'">
                            Disponible
                            <p-treeTableSortIcon [field]="'disponible'" />
                        </th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-rowNode let-node="node">
                    <tr
                        [ttRow]="rowNode"
                        [class.last-node]="isLastNode(rowNode)"
                        [class.first-node]="isFirstNode(rowNode)"
                        [class.expanded-node]="rowNode?.node.expanded"
                    >
                        <td colspan="2">
                            <div class="flex">
                                <p-treeTableToggler
                                    [rowNode]="rowNode"
                                ></p-treeTableToggler>
                                {{ node.data.nombre }}
                            </div>
                        </td>
                        <td style="text-align: center">
                            <p-knob
                                [readonly]="true"
                                [(ngModel)]="node.data.porc_utilizado"
                                [valueTemplate]="node.data.porc_utilizado + '%'"
                                [size]="50"
                                [valueColor]="
                                    getProgressColor(node.data.procesoAnimado)
                                "
                            ></p-knob>
                        </td>
                        <td>
                            {{
                                node.data.limite_credito
                                    | currency : "" : "" : "0.0" : "es-PY"
                            }}
                        </td>
                        <td>
                            {{
                                node.data.consumo_credito
                                    | currency : "" : "" : "0.0" : "es-PY"
                            }}
                        </td>
                        <td>
                            {{
                                node.data.disponible
                                    | currency : "" : "" : "0.0" : "es-PY"
                            }}
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="3">
                            No se encontraron datos para mostrar...
                        </td>
                    </tr>
                </ng-template>
            </p-treeTable>
        </div>
    </div>
    <div
        class="col-12 p-1"
        *ngIf="
            (credito === PREPAGO &&
                isMobileView &&
                (permiso_administrador || contieneLimitePrepago)) ||
            (!isMobileView && (permiso_administrador || contieneLimitePrepago))
        "
        [ngClass]="{ 'md:col-12': permiso_boca, 'md:col-6': !permiso_boca }"
    >
        <div class="card p-3 pr-5">
            <div class="grid flex justify-content-between">
                <div
                    class="col-12 md:col-7 flex text-align-center justify-content-center limite-credito"
                    *ngIf="!isMobileView"
                >
                    <b>Consumo de Límite de Crédito - PREPAGO</b>
                </div>
                <div
                    class="col-12 md:col-7 flex text-align-center justify-content-center"
                    *ngIf="isMobileView"
                >
                    <b>Consumo de Límite de Crédito</b>
                </div>
                <div
                    class="col-12 md:col-7 p-0"
                    *ngIf="isMobileView && filtro_admin"
                >
                    <p-selectButton
                        [unselectable]="true"
                        class="flex justify-content-center"
                        [(ngModel)]="credito"
                        [options]="tipo_creditos"
                        optionLabel="nombre"
                        optionValue="valor"
                        (onChange)="tipoCredito($event)"
                    ></p-selectButton>
                </div>
                <div class="p-inputgroup col-12 md:col-5">
                    <span class="p-inputgroup-addon"
                        ><i class="pi pi-search"></i
                    ></span>
                    <input
                        type="text"
                        pInputText
                        placeholder="Buscar..."
                        (keydown)="filterDataPrepago($event)"
                    />
                </div>
            </div>

            <p-treeTable
                #dt1
                [value]="limitePrepago"
                dataKey="id"
                [paginator]="true"
                [rows]="10"
                [scrollable]="true"
                styleClass="p-treetable-gridlines"
                sortMode="single"
                [globalFilterFields]="['nombre']"
                filterMode="strict"
                [rowsPerPageOptions]="[10, 20, 50]"
            >
                >
                <ng-template pTemplate="header">
                    <tr>
                        <th [ttSortableColumn]="'nombre'" colspan="2">
                            Nombre <p-treeTableSortIcon [field]="'nombre'" />
                        </th>
                        <th [ttSortableColumn]="'disponible'">
                            Disponible
                            <p-treeTableSortIcon [field]="'disponible'" />
                        </th>
                        <th [ttSortableColumn]="'consumo_credito'">
                            Usado
                            <p-treeTableSortIcon [field]="'consumo_credito'" />
                        </th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-rowNode let-node="node">
                    <tr
                        [ttRow]="rowNode"
                        [class.last-node]="isLastNode(rowNode)"
                        [class.first-node]="isFirstNode(rowNode)"
                        [class.expanded-node]="rowNode?.node.expanded"
                    >
                        <td colspan="2">
                            <div class="flex">
                                <p-treeTableToggler
                                    [rowNode]="rowNode"
                                ></p-treeTableToggler>
                                {{ node.data.nombre }}
                            </div>
                        </td>
                        <td>
                            {{
                                node.data.disponible
                                    | currency : "" : "" : "0.0" : "es-PY"
                            }}
                        </td>
                        <td>
                            {{
                                node.data.consumo_credito
                                    | currency : "" : "" : "0.0" : "es-PY"
                            }}
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="3">
                            No se encontraron datos para mostrar...
                        </td>
                    </tr>
                </ng-template>
            </p-treeTable>
        </div>
    </div>
    <div
        class="col-12 md:col-6 p-1"
        *ngIf="
            (acreditacion === POSPAGO &&
                isMobileView &&
                contieneAcreditacionPospago &&
                !permiso_boca) ||
            (!isMobileView && contieneAcreditacionPospago && !permiso_boca)
        "
    >
        <div class="card p-3 pr-5">
            <div class="grid flex justify-content-between">
                <div
                    class="col-12 flex text-align-center justify-content-center limite-credito"
                    *ngIf="!isMobileView"
                >
                    <b>Últimas Acreditaciones - POSPAGO</b>
                </div>
                <div
                    class="col-12 flex text-align-center justify-content-center"
                    *ngIf="isMobileView"
                >
                    <b>Últimas Acreditaciones</b>
                </div>
                <div class="col-12 p-0" *ngIf="isMobileView && filtro_admin">
                    <p-selectButton
                        [unselectable]="true"
                        class="flex justify-content-center"
                        [(ngModel)]="acreditacion"
                        [options]="tipo_creditos"
                        optionLabel="nombre"
                        optionValue="valor"
                        (onChange)="tipoAcreditacion($event)"
                    ></p-selectButton>
                </div>
            </div>

            <p-table
                #dt
                styleClass="p-datatable-sm p-datatable-gridlines"
                [value]="acreditacionPospago"
                [paginator]="true"
                [rows]="10"
                [showCurrentPageReport]="true"
                [rowsPerPageOptions]="[10, 20, 50]"
                [globalFilterFields]="['nombre']"
                currentPageReportTemplate="Mostrando {first} a {last} de {{
                    totalAcreditacionPospago
                }} entradas"
            >
                <ng-template pTemplate="header">
                    <tr>
                        <th
                            class="cabecera align-center"
                            pSortableColumn="nro_transaccion"
                        >
                            Nro.
                            <p-sortIcon field="nro_transaccion"></p-sortIcon>
                        </th>
                        <th
                            class="cabecera align-center"
                            pSortableColumn="fecha_transaccion"
                        >
                            Fecha
                            <p-sortIcon field="fecha_transaccion"></p-sortIcon>
                        </th>
                        <th
                            class="cabecera align-center"
                            pSortableColumn="nombre_empresa"
                        >
                            Empresa
                            <p-sortIcon field="nombre_empresa"></p-sortIcon>
                        </th>
                        <th
                            class="cabecera align-center"
                            pSortableColumn="nombre_sucursal"
                        >
                            Sucursal
                            <p-sortIcon field="nombre_sucursal"></p-sortIcon>
                        </th>
                        <th
                            class="cabecera align-center"
                            pSortableColumn="tipo"
                        >
                            Tipo <p-sortIcon field="tipo"></p-sortIcon>
                        </th>
                        <th
                            class="cabecera align-center"
                            pSortableColumn="importe"
                        >
                            Importe <p-sortIcon field="importe"></p-sortIcon>
                        </th>
                        <th
                            class="cabecera align-center"
                            pSortableColumn="aprobado"
                        >
                            Estado<p-sortIcon field="aprobado"></p-sortIcon>
                        </th>
                        <th class="cabecera align-center"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-empresa>
                    <tr>
                        <td class="consumo-string">
                            {{ empresa.cantidad_pospago }}
                        </td>
                        <td class="consumo-string">
                            {{
                                empresa.fecha_transaccion | date : "dd/MM/yyyy"
                            }}
                        </td>
                        <td class="consumo-string">
                            {{ empresa.nombre_empresa }}
                        </td>
                        <td class="consumo-string">
                            {{ empresa.nombre_sucursal }}
                        </td>
                        <td style="text-align: center">
                            <p-badge
                                class="flex justify-content-center"
                                [value]="getTipo(empresa.tipo)"
                                [severity]="getSeverity(empresa.tipo)"
                            ></p-badge>
                        </td>
                        <td class="consumo-monto">
                            {{
                                empresa.importe
                                    | currency : "" : "" : "0.0-0" : "es-PY"
                            }}
                        </td>
                        <td style="text-align: center">
                            <p-badge
                                [value]="getEstado(empresa.aprobado)"
                                [severity]="
                                    empresa.aprobado ? 'success' : 'danger'
                                "
                            ></p-badge>
                        </td>
                        <td style="text-align: center">
                            <button
                                pButton
                                type="button"
                                icon="pi pi-search"
                                class="p-button-rounded"
                                (click)="buscarAcreditacion(empresa)"
                                severity="danger"
                            ></button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
    <div
        class="col-12 md:col-6 p-1"
        *ngIf="
            (acreditacion === PREPAGO &&
                isMobileView &&
                contieneAcreditacionPrepago &&
                !permiso_boca) ||
            (!isMobileView && contieneAcreditacionPrepago && !permiso_boca)
        "
    >
        <div class="card p-3 pr-5">
            <div class="grid flex justify-content-between">
                <div
                    class="col-12 flex text-align-center justify-content-center limite-credito"
                    *ngIf="!isMobileView"
                >
                    <b>Últimas Acreditaciones - PREPAGO </b>
                </div>
                <div
                    class="col-12 flex text-align-center justify-content-center"
                    *ngIf="isMobileView"
                >
                    <b>Últimas Acreditaciones</b>
                </div>
                <div class="col-12 p-0" *ngIf="isMobileView && filtro_admin">
                    <p-selectButton
                        [unselectable]="true"
                        class="flex justify-content-center"
                        [(ngModel)]="acreditacion"
                        [options]="tipo_creditos"
                        optionLabel="nombre"
                        optionValue="valor"
                        (onChange)="tipoAcreditacion($event)"
                    ></p-selectButton>
                </div>
            </div>
            <p-table
                #dt1
                styleClass="p-datatable-sm p-datatable-gridlines"
                [value]="acreditacionPrepago"
                [paginator]="true"
                [rows]="10"
                [showCurrentPageReport]="true"
                [rowsPerPageOptions]="[10, 20, 50]"
                [globalFilterFields]="['nombre_empresa']"
                currentPageReportTemplate="Mostrando {first} a {last} de {{
                    totalAcreditacionPrepago
                }} entradas"
            >
                <ng-template pTemplate="header">
                    <tr>
                        <th
                            class="cabecera align-center"
                            pSortableColumn="nro_transaccion"
                        >
                            Nro.
                            <p-sortIcon field="nro_transaccion"></p-sortIcon>
                        </th>
                        <th
                            class="cabecera align-center"
                            pSortableColumn="fecha_transaccion"
                        >
                            Fecha
                            <p-sortIcon field="fecha_transaccion"></p-sortIcon>
                        </th>
                        <th
                            class="cabecera align-center"
                            pSortableColumn="nombre_empresa"
                        >
                            Empresa
                            <p-sortIcon field="nombre_empresa"></p-sortIcon>
                        </th>
                        <th
                            class="cabecera align-center"
                            pSortableColumn="nombre_sucursal"
                        >
                            Sucursal
                            <p-sortIcon field="nombre_sucursal"></p-sortIcon>
                        </th>
                        <th
                            class="cabecera align-center"
                            pSortableColumn="tipo"
                        >
                            Tipo <p-sortIcon field="tipo"></p-sortIcon>
                        </th>
                        <th
                            class="cabecera align-center"
                            pSortableColumn="importe"
                        >
                            Importe <p-sortIcon field="importe"></p-sortIcon>
                        </th>
                        <th
                            class="cabecera align-center"
                            pSortableColumn="aprobado"
                        >
                            Estado<p-sortIcon field="aprobado"></p-sortIcon>
                        </th>
                        <th class="cabecera align-center"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-empresa>
                    <tr>
                        <td class="consumo-string">
                            {{ empresa.cantidad_prepago }}
                        </td>
                        <td class="consumo-string">
                            {{
                                empresa.fecha_transaccion | date : "dd/MM/yyyy"
                            }}
                        </td>
                        <td class="consumo-string">
                            {{ empresa.nombre_empresa }}
                        </td>
                        <td class="consumo-string">
                            {{ empresa.nombre_sucursal }}
                        </td>
                        <td style="text-align: center">
                            <p-badge
                                class="flex justify-content-center tipo"
                                [value]="getTipo(empresa.tipo)"
                                [severity]="getSeverity(empresa.tipo)"
                            ></p-badge>
                        </td>
                        <td class="consumo-monto">
                            {{
                                empresa.importe
                                    | currency : "" : "" : "0.0-0" : "es-PY"
                            }}
                        </td>
                        <td style="text-align: center">
                            <p-badge
                                [value]="getEstado(empresa.aprobado)"
                                [severity]="
                                    empresa.aprobado ? 'success' : 'danger'
                                "
                            ></p-badge>
                        </td>
                        <td style="text-align: center">
                            <button
                                pButton
                                type="button"
                                icon="pi pi-search"
                                class="p-button-rounded"
                                (click)="buscarAcreditacion(empresa)"
                                severity="danger"
                            ></button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
